import { pesIconSizes } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';
import { BSL_IMAGE_SIZE_RENDITION_MAP } from '../constants/constants';
import { CreatePesIconOptions, CreateURLOptions } from './types';
/**
 * Converts BSL image URL to URL to image with specified size.
 *
 * @param {string} url BSL image URL optionally containing `p_File_Ext` and `p_File_Type`.
 * @param {64|113|200|288|369} size
 * @returns {string}
 */
export function getBSLImageURL(url, size) {
  try {
    const urlObj = new URL(url);
    const searchParams = new URLSearchParams(urlObj.search);

    searchParams.delete('p_File_Ext');
    searchParams.set('p_File_Type', BSL_IMAGE_SIZE_RENDITION_MAP[size]);

    urlObj.search = searchParams.toString();

    return urlObj.toString();
  } catch {
    return url;
  }
}

/**
 * @function getValueByNs
 * @methodOf utils module
 * @param {*} obj
 * @param {string} path
 * @param {*} defaultValue
 * @returns {*}
 * @description return value from object by string path or default value
 */
export function getValueByNs(obj, path, defaultValue = '') {
  const keys = path.split('.');

  keys.forEach((key) => {
    if (obj) {
      obj = obj[key];
    }
  });

  return obj || defaultValue;
}

/**
 * Checks whether its argument represents a numeric value.
 *
 * @param {?any} value To check.
 * @returns {boolean}
 */
export const isNumeric = (value) => {
  const parsedValue = parseFloat(value);

  return !Number.isNaN(parsedValue) && Number.isFinite(parsedValue);
};

export const htmlUnEscape = (input) => {
  const e = document.createElement('div');

  e.innerHTML = input;
  return e.childNodes.length === 0 ? '' : e.childNodes[0].nodeValue;
};


export const createUrl = ({
  host,
  contextRoot,
  endpoint,
  queryParams
} : CreateURLOptions) => {
  let path = endpoint;
  if (contextRoot) path = `${contextRoot}${path}`;

  if (host) path = `${host}${path}`;

  const params = [];
  for(const key in queryParams) params.push(`${key}=${queryParams[key]}`);

  return`${path}?${params.join('&')}`;
};

export const createPesIcon = ({ iconName, size, className }: CreatePesIconOptions): HTMLElement | null => {
  if(!iconName) return null;
  const pesIconElement = document.createElement('pes-icon');
  if(className) pesIconElement.setAttribute('className', className);
  if(size) pesIconElement.setAttribute('size', pesIconSizes[size]);
  pesIconElement.innerText = iconName;
  return pesIconElement;
};
